import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { DiscountTypesApi } from '@trybeapp/sdk.shop'
import { useParams } from 'react-router-dom'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { usePageQueryParam } from 'hooks/UsePageQueryParam'

const api = new DiscountTypesApi()

export const useDiscountTypes = (params: any = {}, options) => {
  const siteId = useCurrentSiteId()
  params.siteId = params.siteId ?? siteId

  return useQuery(
    ['discountTypes', { params }],
    async () => await api.discountTypesIndex(params),
    options
  )
}

export const useDiscountTypesForPageParam = (params: any = {}, options?: UseQueryOptions) => {
  const [page] = usePageQueryParam()
  params.page = page

  return useDiscountTypes({ page, ...params }, options)
}

export const useDiscountType = (discountTypeId: string, options = {}) =>
  useQuery(
    ['discountTypes', { discountTypeId }],
    async () => await api.getDiscountType(discountTypeId),
    options
  )

export const useDiscountTypeForParam = () => {
  const { discountTypeId } = useParams()

  return useDiscountType(discountTypeId)
}

export const useCreateDiscountType = () => {
  const siteId = useCurrentSiteId()

  return useMutation<unknown, unknown, { [key: string]: any }>(
    async (discountType) =>
      (await api.createDiscountType({ ...discountType, site_id: siteId })).data
  )
}

export const useUpdateDiscountType = (options = {}) => {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, [string, { [key: string]: any }]>(
    ([discountTypeId, values]) => api.updateDiscountType(discountTypeId, values),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries('discountTypes')
      },
    }
  )
}

export const useDeleteDiscountType = () => {
  const queryClient = useQueryClient()

  return useMutation(async (discountTypeId) => await api.deleteDiscountType(discountTypeId), {
    onSuccess: () => {
      queryClient.invalidateQueries('discountTypes')
    },
  })
}

export const useRestoreDiscountType = () => {
  const queryClient = useQueryClient()

  return useMutation((discountTypeId) => api.restoreDiscountType(discountTypeId), {
    onSuccess: () => {
      queryClient.invalidateQueries('discountTypes')
    },
  })
}
